import * as React from "react";
import { Form, useFormApi, useFormState } from "informed";
import { TextBox } from "../../forms/informedv2/TextBox";
import { Link } from "react-router-dom";
import Alert, { AlertCategoryEnum } from "../../misc/components/Alert";
import { Required } from "../../forms/validation/Required";
import { useCurrentStudyConfigurationContext } from "../../Core/CurrentStudyConfigurationContext";
import { useWebPortalApiClient, useWebPortalLegacyClient } from "../../misc/api/WebPortalTokenClient";
import { MultiSelect } from "../../forms/informedv2/MultiSelect";
import { Query, Report } from "../../misc/api/apiTypes";

export const CreateRole = () => {
    return (
        <Form>
            <CreateRoleForm />
        </Form>
    );
}

export interface CreateRoleFormModel {
    name: string;
}

const CreateRoleForm = () => {
    const client = useWebPortalApiClient();
    const legacyClient = useWebPortalLegacyClient();
    const formApi = useFormApi<CreateRoleFormModel>();
    const formState = useFormState<CreateRoleFormModel>();
    const [selectedFile, setSelectedFile] = React.useState<File>();
    const [errorAlert, setErrorAlert] = React.useState<string>();
    const [successAlert, setSuccessAlert] = React.useState(false);
    const { study } = useCurrentStudyConfigurationContext();

    


    const onSaveClick = async () => {
        setErrorAlert(undefined);
        formApi.validate();
        const state = formApi.getState();

        if (state.invalid) {
            setSuccessAlert(false);
            return setErrorAlert("Errors exist on the page");
        }

        try {
            const role = await client.client.postRole({
                name: state.values.name,
                studyId: study.id
            });

            if (selectedFile !== undefined) {
                await legacyClient.importPermissionsApi(role.id, selectedFile);
            }

            setSuccessAlert(true);
        } catch (ex) {
            if (ex.message || ex.Message) {
                return setErrorAlert(ex.message ?? ex.Message);
            }
        }
    }

    return (
        <>
            <Alert show={successAlert} category={AlertCategoryEnum.Success}>
                Saved successfully. Return to{" "}
                <Link to={`/rolemanagement`}>Role Management</Link>?
            </Alert>
            <Alert show={errorAlert !== undefined} category={AlertCategoryEnum.Danger}>
                {errorAlert}
            </Alert>
            <div className="row">
                <div className="col-md-6">
                    <h2 className="text-primary">Create Role</h2>
                </div>
                <div className="col-md-6">
                    <div className="h2 pull-right">
                        <button id="saveButton" className="btn btn-primary" type="button" disabled={false} onClick={onSaveClick}>
                            Save
                        </button>&nbsp;
                        <Link id="returnToListButton" className="btn btn-primary btn-outline" to="/rolemanagement">
                            Return to List
                        </Link>
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-md-12">
                    <div id="createRolePanel" className="panel panel-primary">
                        <div className="panel-body">
                            <div className="row">
                                <div className="form-group col-sm-6 col-xs-12">
                                    <label htmlFor="name">Name</label>
                                    <TextBox id="name" field="name" validate={Required} required={true} />
                                </div>
                                <div className="form-group col-sm-6 col-xs-12">
                                    <label>Import Permissions</label>
                                    <input type="file" className="form-control" onChange={(e) => setSelectedFile(e.target.files[0])} />
                                    <span className="help-text">Optional. Choose file if importing from a previously exported role.</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
